export default __webpack_public_path__ + "static/media/service4.bd831301.png";